module.exports = __webpack_public_path__ + "img/jiantou.99c8d384.svg";